import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';
import { AccelerationNeedsScheduleRequest, IAccelerationNeedsScheduleResult } from '../serverApi/requests/AccelerationNeedsScheduleRequest';
import { AdminAllowDataAccelerationForViews } from '../serverApi/requests/AdminAllowDataAccelerationRequest';
import { AdminDisallowDataAccelerationForViews } from '../serverApi/requests/AdminDisallowDataAccelerationRequest';
import { FindAcceleratedViewLimitInfo, IFindAcceleratedViewLimitInfoResult } from '../serverApi/requests/FindAcceleratedViewLimitInfoRequest';
import { FindNumberOfSheetsEnabledForAccelerationRequest, IFindNumberOfSheetsEnabledForAccelerationResult } from '../serverApi/requests/FindNumberOfSheetsEnabledForAccelerationRequest';
import { GetAccelerationTasksRequest } from '../serverApi/requests/GetAccelerationTasksRequest';
class AccelerationTasksResource implements IListResource<IAccelerationTaskInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetAccelerationTasksRequest, ServerApiMapper.accelerationTasks);

  public all(): ResourceQuery<IAccelerationTaskInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public needsSchedule(ids: string[]): Promise<IAccelerationNeedsScheduleResult> {
    return WebHttpClient.sendRequest(new AccelerationNeedsScheduleRequest({targetIds: ids}));
  }

  public adminAllowDataAccelerationForViews(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids,
        (idsBlock) => new AdminAllowDataAccelerationForViews({
          targetIds: idsBlock,
        })),
      ResultHelper.combineResults);
  }

  public adminDisallowDataAccelerationForViews(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids,
        (idsBlock) => new AdminDisallowDataAccelerationForViews({
          targetIds: idsBlock,
        })),
      ResultHelper.combineResults);
  }

  public findNumberOfEnabledSheets(): Promise<IFindNumberOfSheetsEnabledForAccelerationResult> {
    return WebHttpClient.sendRequest(
      new FindNumberOfSheetsEnabledForAccelerationRequest());
  }

  public findAcceleratedViewLimitInfo(): Promise<IFindAcceleratedViewLimitInfoResult> {
    return WebHttpClient.sendRequest(
      new FindAcceleratedViewLimitInfo());
  }
}

export const AccelerationTasks = new AccelerationTasksResource();


